import { Box, Typography, Checkbox } from '@mui/material';
import React, { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import KenButton from '../../../GlobalComponents/KenButton';
import { useTheme } from '@mui/material/styles';
import { useStyles } from '../styles';

const Filters = (props: any) => {
  const theme = useTheme();
  const classes = useStyles();
  const style = {
    position: 'absolute' as 'absolute',
    top: { xs: '50%', sm: '50%', md: '57%', lg: '57%', xl: '57%' },
    left: { xs: '50%', sm: '50%', md: '70%', lg: '70%', xl: '70%' },
    transform: 'translate(-50%, -50%)',
    width: { md: '280px', lg: '280px', xl: '280px' },
    height: '450px',
    [theme.breakpoints.up('xxl')]: {
      height: '567px',
    },
    bgcolor: 'background.paper',
    boxShadow: 5,
    borderRadius: '12px',
    p: 3,
  };
  const { handleClose, jobFilterData, selectedValues, setSelectedValues, handleDropDownChange } = props;

  const handleChange = (event: any, index: string) => {
    const { value } = event.target;

    const selectedValue = Array.isArray(value) ? value : [value];

    console.log('index', event, index);

    if (index === 'Salary') {
      const salaryRanges = selectedValue
        .map((range: string) => {
          const salaryRange = range.replace(' LPA', '').split('-');
          if (salaryRange.length === 2) {
            return {
              start: parseInt(salaryRange[0]),
              end: parseInt(salaryRange[1]),
            };
          } else {
            console.error('Invalid salary range format', salaryRange);
            return null;
          }
        })
        .filter(Boolean);

      setSelectedValues((prevValues: any) => ({
        ...prevValues,
        Salary_Start_Range__c: salaryRanges.map((range: any) => range.start),
        Salary_End_Range__c: salaryRanges.map((range: any) => range.end),
        [index]: selectedValue,
      }));
    } else {
      setSelectedValues((prevValues: any) => ({
        ...prevValues,
        [index]: selectedValue,
      }));
    }
  };

  console.log('selectedValues23', selectedValues);

  const data = [
    {
      title: 'Job title',
      key: 'Job_Title__c',
      value: jobFilterData.jobTitles,
    },
    {
      title: 'Company',
      key: 'Organization__r.Name',
      value: jobFilterData.companies,
    },
    {
      title: 'Workplace type',
      key: 'Work_Place_Type__c',
      value: ['Remote', 'Onsite', 'Hybrid'],
    },
    {
      title: 'Posted by',
      key: 'Posted_by',
      value: ['Anyone', 'myself'],
    },
    {
      title: 'Job location',
      key: 'Location__c',
      value: jobFilterData.locations,
    },
    {
      title: 'Posted On',
      key: 'Posted On',
      value: ['Anytime', 'Past Month', 'Past week', 'Past 24 hours'],
    },
    {
      title: 'Job type',
      key: 'Job_Type__c',
      value: jobFilterData.jobTypes,
    },
    {
      title: 'Salary',
      key: 'Salary',
      value: jobFilterData.salaryRanges,
    },
    {
      title: 'Skills',
      key: 'Skill_Required__c',
      value: jobFilterData.skills,
    },
  ];
  return (
    <div>
      <Box sx={style}>
        <Typography sx={{ fontSize: '15px', fontWeight: 600 }}>Filters</Typography>
        <Box className={`${classes.filterBox} scrollbar-cusgray`}>
          {data?.map((val: any, index) => (
            <Box sx={{ width: '100%', mt: 3 }} key={index}>
              <FormControl fullWidth>
                <InputLabel id={`select-label-${index}`} sx={{ fontSize: '12px', fontWeight: 500 }}>
                  {val.title}
                </InputLabel>
                {/* <Select
                  labelId={`select-label-${index}`}
                  id={`select-${index}`}
                  value={selectedValues[val.key] || ''}
                  label={<Typography sx={{ fontSize: '12px', fontWeight: 500 }}>{val.title}</Typography>}
                  onChange={(event) => {
                    handleChange(event, val.key);
                  }}
                  sx={{
                    height: '45px',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF',
                    },
                  }}
                >
                  {val?.value?.map((option: string, optionIndex: number) => (
                    <MenuItem
                      key={optionIndex}
                      value={option}
                      sx={{
                        '&.Mui-selected': {
                          backgroundColor: 'transparent',
                        },
                        '&.Mui-selected:hover': {
                          backgroundColor: 'transparent',
                        },
                        '&:hover': {
                          backgroundColor: 'transparent',
                        },
                        '&:active': {
                          backgroundColor: 'transparent',
                        },
                      }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Select> */}
                <Select
                  labelId={`select-label-${index}`}
                  id={`select-${index}`}
                  multiple
                  value={selectedValues[val.key] || []} 
                  label={<Typography sx={{ fontSize: '12px', fontWeight: 500 }}>{val.title}</Typography>}
                  onChange={(event) => handleChange(event, val.key)}
                  sx={{
                    height: '45px',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF',
                    },
                  }}
                  renderValue={(selected) => selected?.join(', ')}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                        width: 200, 
                      },
                    },
                  }}
                >
                  {val?.value?.map((option: string, optionIndex: number) => (
                    <MenuItem
                      key={optionIndex}
                      value={option}
                      sx={{
                        height: '50px',
                        width: '150px',
                        padding: '10px',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Checkbox
                        checked={selectedValues[val.key]?.includes(option)}
                        sx={{
                          marginRight: 1,
                          padding: 0,
                        }}
                      />
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ))}
        </Box>
        <hr />
        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
          <KenButton
            variant="text"
            sx={{
              mt: 2,
              borderRadius: '8px',
              fontweight: 500,
              backgroundColor: 'none',
              '&:hover': {
                backgroundColor: 'transparent',
              },
              color: 'black',
              width: 100,
            }}
            onClick={handleClose}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#373A45' }}>Cancel</Typography>
          </KenButton>
          <KenButton
            variant="contained"
            onClick={() => {
              handleDropDownChange(selectedValues);
              handleClose();
              setSelectedValues([]);
            }}
            style={{
              width: 100,
              marginTop: 15,
              borderRadius: '7px',
              boxShadow: 'none',
              '& hover': {
                boxShadow: 'none',
              },
            }}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>Apply</Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default Filters;
